const INITIAL_STATE = {
  getGeocode: {},
  errors: {},
}

const googleApi = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_GEOCODE':
    return { ...state, ...INITIAL_STATE, getGeocode: action.data }
  case 'GET_GEOCODE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default googleApi;